export const FINANCIAL_YEARS_RESET_STATE = 'FINANCIAL_YEARS_RESET_STATE';
export const FINANCIAL_YEARS_CURRENT_ITEM = 'FINANCIAL_YEARS_CURRENT_ITEM';

export const FINANCIAL_YEARS_REQUEST_LOADING = 'FINANCIAL_YEARS_REQUEST_LOADING';
export const FINANCIAL_YEARS_REQUEST_SUCCESS = 'FINANCIAL_YEARS_REQUEST_SUCCESS';
export const FINANCIAL_YEARS_REQUEST_FAILED = 'FINANCIAL_YEARS_REQUEST_FAILED';

export const FINANCIAL_YEARS_CURRENT_ACTION = 'FINANCIAL_YEARS_CURRENT_ACTION';
export const FINANCIAL_YEARS_RESET_ACTION = 'FINANCIAL_YEARS_RESET_ACTION';